import { RegistrationData } from 'feature/registration/types'

import { createEmptyAddress } from 'feature/registration/heplers/addressHelpers'

const prefix = 'reg_form_'

export const authStorageName = {
  firstName: `${prefix}first_name`,
  lastName: `${prefix}last_name`,
  middleName: `${prefix}middle_name`,
  address: `${prefix}address`,
}

export const getRegistrationFields = (): RegistrationData => ({
  firstname: sessionStorage.getItem(authStorageName.firstName) || '',
  lastname: sessionStorage.getItem(authStorageName.lastName) || '',
  middlename: sessionStorage.getItem(authStorageName.middleName) || '',
  address: sessionStorage.getItem(authStorageName.address)?.length
    ? // @ts-ignore
      JSON.parse(sessionStorage.getItem(authStorageName.address))
    : createEmptyAddress(),
  personalAgree: false,
})

export const deleteRegistrationFields = () => {
  try {
    sessionStorage.removeItem(authStorageName.firstName)
    sessionStorage.removeItem(authStorageName.lastName)
    sessionStorage.removeItem(authStorageName.middleName)
    sessionStorage.removeItem(authStorageName.address)
  } catch (error) {
    console.error('Ошибка при удалении элементов sessionStorage:', error)
  }
}

export const setRegistrationFields = (watchFields: RegistrationData) => {
  const { firstname, lastname, middlename, address } = watchFields
  if (firstname || lastname || middlename) {
    sessionStorage.setItem(authStorageName.firstName, firstname)
    sessionStorage.setItem(authStorageName.lastName, lastname)
    sessionStorage.setItem(authStorageName.middleName, middlename)
  }
  if (address) {
    sessionStorage.setItem(authStorageName.address, JSON.stringify(address))
  } else sessionStorage.removeItem(authStorageName.address)
}

export const setEmptyRegistrationFields = (): RegistrationData => ({
  firstname: '',
  lastname: '',
  middlename: '',
  address: createEmptyAddress(),
  personalAgree: false,
})
